import TabsController from 'controllers/tabs-controller'

export default class SlideshowController extends TabsController {
  static targets = ['previousButton', 'nextButton']

  connect () {
    super.connect()
  }

  handleLoopClick () {
    const next = this.activeIndex + 1
    this.activateByPanel({ panel: this.panelsTargets[next] || this.panelsTargets[0] })
    this.pushPanelToHistory()
  }

  handlePreviousButtonClick () {
    this.activateByPanel({ panel: this.panelsTargets[this.activeIndex - 1] })
    this.pushPanelToHistory()
  }

  handleNextButtonClick () {
    this.activateByPanel({ panel: this.panelsTargets[this.activeIndex + 1] })
    this.pushPanelToHistory()
  }

  activateByPanel (args) {
    super.activateByPanel(args)
    this.handleButtonsAvailability()
  }

  handleButtonsAvailability () {
    if (this.activeIndex < 1) {
      this.constructor.disableButton(this.previousButtonTarget)
    } else {
      this.constructor.enableButton(this.previousButtonTarget)
    }

    if (this.activeIndex + 1 >= this.panelsTargets.length) {
      this.constructor.disableButton(this.nextButtonTarget)
    } else {
      this.constructor.enableButton(this.nextButtonTarget)
    }
  }

  static disableButton (button) {
    button && (button.style.opacity = '0')
  }

  static enableButton (button) {
    button && (button.style.opacity = '1')
  }
}
